import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { Container, theme, useResponsive } from '@sg/garnish';

import { PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH } from '../../../../PartnerLineItem.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemHeroContainer = (props: PropsWithChildren) => {
  const { children } = props;

  const { match } = useResponsive();

  // ─── Styles ──────────────────────────────────────────────────────────

  const containerStyles = [styles.innerContainer, match([styles.innerContainerXS, undefined])];
  const heroStyles = [styles.hero, match([styles.heroXS, styles.heroSM])];

  // ─────────────────────────────────────────────────────────────────────

  return (
    <Container style={containerStyles}>
      <View style={heroStyles}>{children}</View>
    </Container>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  innerContainer: {
    alignItems: 'center',
    maxWidth: PARTNER_LINE_ITEM_CONTENT_MAX_WIDTH,
  },
  innerContainerXS: {
    paddingHorizontal: theme.spacing['6'],
  },
  hero: {
    alignSelf: 'stretch',
  },
  heroXS: {
    alignItems: 'center',
    gap: theme.spacing['8'],
    paddingBottom: theme.spacing['6'],
  },
  heroSM: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing['10'],
    paddingVertical: theme.spacing['15'],
  },
});
